import { render, staticRenderFns } from "./access.vue?vue&type=template&id=e595db00&scoped=true"
import script from "./access.vue?vue&type=script&lang=js"
export * from "./access.vue?vue&type=script&lang=js"
import style0 from "./access.vue?vue&type=style&index=0&id=e595db00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e595db00",
  null
  
)

export default component.exports